import React, { useContext } from 'react';
import BuzzContext from '../../contexts/buzz';
import dynamicImport from '../../utils/dynamic-import';
import LazyLoad from '../LazyLoad';
import { isEligible, newsletterConfiguration } from '../../utils/newsletters';

const NewsletterSignup = dynamicImport(
  () => import(/* webpackChunkName: "newsletter-signup" */ './index.jsx'),
  { ssr: false }
);

export default function NewsletterSignupLazy(props) {
  const { buzz = {} } = useContext(BuzzContext);
  if (!isEligible(buzz)) {
    return null;
  }

  const config = newsletterConfiguration({ ...(buzz.classification || {}), isNews: buzz.isNews });
  if (!config) {
    return null;
  }

  return (
    <LazyLoad>
      <NewsletterSignup {...props} config={config} />
    </LazyLoad>
  );
}
